import { Link, Navigate, useParams } from 'react-router';

import { Button } from '@/components/ui/button';
import IAPDashboard from 'components/IAP/IAPDashboardNew';
import { usePositionWorkspacesFlag } from 'utils/featureFlags';

import { useActiveSeatNav } from './useActiveSeats';

export function SeatLanding() {
  const { incidentId } = useParams<{ incidentId: string }>();
  const workspacesOn = usePositionWorkspacesFlag();
  const { held, rosterLoading } = useActiveSeatNav();

  if (!workspacesOn || !incidentId) return <IAPDashboard />;
  if (rosterLoading) return null;

  const landing = held;

  if (landing.kind === 'one') {
    return (
      <Navigate to={`/iap/${incidentId}/seat/${landing.slug}`} replace />
    );
  }
  if (landing.kind === 'many') {
    return (
      <div className="dark tw:flex tw:flex-col tw:items-start tw:gap-2 tw:bg-background tw:p-4 tw:text-foreground">
        <h1 className="tw:m-0 tw:text-lg tw:font-medium">Your seats</h1>
        {landing.seats.map((seat) => (
          <Button
            key={seat.slug}
            variant="link"
            size="sm"
            className="tw:h-auto tw:px-0"
            render={<Link to={`/iap/${incidentId}/seat/${seat.slug}`} />}
          >
            {seat.label}
          </Button>
        ))}
      </div>
    );
  }
  return <IAPDashboard />;
}
